
import { Bookmark } from "lucide-react";
import { SocialActionButton } from "./SocialActionButton";
import { cn } from "@/lib/utils";

interface FavoriteButtonProps {
  isFavorited: boolean;
  count: number;
  onClick: () => void;
  buttonSize: string;
  iconSize: number;
  theme: string;
}

export function FavoriteButton({
  isFavorited,
  count,
  onClick,
  buttonSize,
  iconSize,
  theme
}: FavoriteButtonProps) {
  const getFavoriteColor = () => {
    if (!isFavorited) return "";
    return theme === 'dark' ? "text-amber-300 bg-amber-400/5" : "text-amber-500 bg-amber-50";
  };

  return (
    <SocialActionButton
      onClick={onClick}
      icon={
        <Bookmark
          className={cn(
            "mr-1.5 transition-transform",
            isFavorited ? "fill-current" : ""
          )}
          size={iconSize}
        />
      }
      count={count}
      tooltipText={isFavorited ? "Retirer des favoris" : "Ajouter aux favoris"}
      buttonSize={buttonSize}
      colorClasses={getFavoriteColor()}
      iconSize={iconSize}
      isActive={isFavorited}
    />
  );
}
